<template>
    <OverlayLoader :isLoading="!productsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.connections.all_products')"
                    icon="fal fa-search"
                    type="search"
                    @catchEmit="toggleSearch"
                />

                <ProductMenu></ProductMenu>

                <WhiteTable
                    v-if="!productsLoading"
                    :customth="true"
                    @changePage="changePage"
                    :showPaginate="true"
                    :paginate="paginate"
                >
                    <template slot="table-header">

                        <tr>
                            <th style="width:20%;">{{$translate.text('clients.connections.product.name')}}</th>
                            <th style="width:20%;">{{$translate.text('clients.connections.product.exception')}}</th>
                            <th style="width:15%;">{{$translate.text('clients.connections.product.type')}}<i ref=buttontest @click="isOpenType = !isOpenType" style="font-size:14px; padding-left:10px;"  :class="{'fas fa-filter' : filterActiveTypes, 'far fa-filter': !filterActiveTypes}"></i>
                                <div v-if="isOpenType">
                                    <ul
                                        class="filterUL"
                                        v-closable="{
                                            exclude: ['buttontest'],
                                            handler: 'handleClickOutsideType'
                                        }"
                                    >
                                        <li v-for="(type, index) in types" :key="index" @click="toggleTypeFilter(type)" class="pointer" style="display: flex;">
                                            <i
                                                :class="{ 'fas fa-check-square' : type.active, 'fal fa-square' : !type.active}"
                                                style="color:white; margin:0px 10px; width: 20px;"
                                            />
                                            <span>{{type.name}}</span>
                                        </li>
                                        <li class="pointer" @click="resetTypeFilters" style="display: flex;">
                                            <i class="fal fa-times" style="color:white; margin:0px 10px; width: 20px;"></i>
                                            <span>{{$translate.text('filters.remove')}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </th>
                            <th style="width:15%;">{{$translate.text('clients.connections.product.batch_number')}}</th>
                            <th style="width:10%;">{{$translate.text('clients.connections.product.row_number')}}</th>
                            <th style="width:10%;" >{{$translate.text('clients.connections.product.unqiue_code')}}</th>
                            <th style="width:10%;">{{$translate.text('clients.connections.product.job')}}<i ref=button @click="isOpenJob = !isOpenJob" style="font-size:14px; padding-left:10px;"  :class="{'fas fa-filter' : filterActiveJobs, 'far fa-filter': !filterActiveJobs}"></i>
                                <div v-if="isOpenJob">
                                    <ul
                                        class="filterUL"
                                        v-closable="{
                                            exclude: ['button'],
                                            handler: 'handleClickOutside'
                                        }"
                                    >
                                        <li v-for="(job, index) in jobs" :key="index" @click="toggleJobFilter(job)" class="pointer" style="display: flex;">
                                            <i
                                                :class="{ 'fas fa-check-square' : job.active, 'fal fa-square' : !job.active}"
                                                style="color:white; margin:0px 10px; width: 20px;"
                                            />
                                            <span>{{job.name}}</span>
                                        </li>
                                        <li class="pointer" @click="resetJobFilters" style="display: flex;">
                                            <i class="fal fa-times" style="color:white; margin:0px 10px; width: 20px;"></i>
                                            <span>{{$translate.text('filters.remove')}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </th>
                        </tr>

                    </template>
                    <template slot="table-data">
                        <tr v-for="product in products" :key="product.id">
                            <td>{{ product.name }}</td>
                            <td>
                                {{ product.exception }}

                                <span v-if="product.stacktrace" @click="openStacktrace(product)" class="inline-link" style="display: block; margin-top:10px;">Stacktrace</span>

                            </td>
                            <td>{{ product.type}}</td>
                            <td>{{ product.batch_number }}</td>
                            <td>{{ product.row_number}}</td>
                            <td>{{ product.unique_code}}</td>
                            <td>{{ product.job}}</td>
                        </tr>
                        <tr v-if="!products.length">
                            <td colspan="7">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
                <div class="overlay-loader" v-else>
                    <div class="spinner"></div>
                </div>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>


// Helpers
import swal from 'sweetalert';
import handleError from '@/helpers/error';
// import selectAll from '@/helpers/selector';

import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';

import ProductMenu from '@/components/ProductsMenu/ProductMenu';


export default {
    name: 'ClientsConnectionsProducts',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        ProductMenu,
    },

    data() {
        return {
            products: {},
            productsLoaded: true,

            productsLoading: false,

            selectedProducts: [],
            allProductsSelected: false,
            connectionId: null,
            isOpenJob: false,
            isOpenType: false,

            filters: {
                search: null,
                filter: {
                    job: [],
                    type: [],
                },
            },

            jobs: {
                collect: {
                    name: this.$translate.text('filters.product.jobs.collect'),
                    value: 'collect',
                    active: false,
                },
                connect: {
                    name: this.$translate.text('filters.product.jobs.connect'),
                    value: 'connect',
                    active: false,
                },
                sync: {
                    name: this.$translate.text('filters.product.jobs.sync'),
                    value: 'sync',
                    active: false,
                },
            },

            types: {
                info: {
                    name: this.$translate.text('filters.product.types.info'),
                    value: 'info',
                    active: false,
                },
                critical: {
                    name: this.$translate.text('filters.product.types.critical'),
                    value: 'critical',
                    active: false,
                },
            },

            paginate: {
                current_page: 1,
            },
        };
    },

    created() {
        this.getProducts();
        this.connectionId = this.$route.params.id;
    },

    methods: {
        getProducts() {
            this.productsLoading = true;
            this.API.clients.connections.productsSyncLog(this.$route.params.id, this.filters, this.paginate.current_page)
                .then((response) => {
                    this.products = response.data.data;
                    this.paginate = response.data.meta;
                    this.productsLoaded = true;
                    this.productsLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        changePage(value) {
            switch (value) {
            case 'next':
                this.paginate.current_page += 1;
                break;
            case 'previous':
                this.paginate.current_page -= 1;
                break;
            default:
                this.paginate.current_page = value;
            }

            this.getProducts();
        },


        toggleJobFilter(filter) {
            filter.active = !filter.active;


            this.filters.filter.job = [];
            Object.keys(this.jobs).forEach(index => {
                if (this.jobs[index].active) {
                    this.filters.filter.job.push(this.jobs[index].value);
                }
            });

            this.paginate.current_page = 1;

            this.getProducts();
        },

        resetJobFilters() {
            Object.keys(this.jobs).forEach(index => {
                this.jobs[index].active = false;
            });
            this.filters.filter.job = [];
            this.isOpenJob = false;
            this.paginate.current_page = 1;
            this.getProducts();
        },

        toggleTypeFilter(filter) {
            filter.active = !filter.active;


            this.filters.filter.type = [];
            Object.keys(this.types).forEach(index => {
                if (this.types[index].active) {
                    this.filters.filter.type.push(this.types[index].value);
                }
            });
            this.paginate.current_page = 1;

            this.getProducts();
        },

        resetTypeFilters() {
            Object.keys(this.types).forEach(index => {
                this.types[index].active = false;
            });
            this.filters.filter.type = [];
            this.isOpenType = false;
            this.paginate.current_page = 1;

            this.getProducts();
        },

        toggleSearch(event) {
            if (event === '') {
                event = null;
            }
            this.filters.search = event;
            this.paginate.current_page = 1;
            this.getProducts();
        },

        handleClickOutside() {
            if (this.isOpenJob) {
                this.isOpenJob = false;
            }
        },

        handleClickOutsideType() {
            if (this.isOpenType) {
                this.isOpenType = false;
            }
        },

        openStacktrace(product) {
            swal({
                title: this.$translate.text('general.stacktrace'),
                text: product.stacktrace,
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$translate.text('general.ok'),
                cancelButtonText: this.$translate.text('general.cancel'),
                reverseButtons: true,
            });
        },
    },

    computed: {
        filterActiveJobs() {
            let bool = false;
            if (this.isOpenJob) {
                return true;
            }
            Object.keys(this.jobs).forEach(index => {
                if (this.jobs[index].active) {
                    bool = true;
                }
            });

            return bool;
        },

        filterActiveTypes() {
            let bool = false;
            if (this.isOpenType) {
                return true;
            }
            Object.keys(this.types).forEach(index => {
                if (this.types[index].active) {
                    bool = true;
                }
            });

            return bool;
        },
    },
};
</script>
<style lang="scss" scoped>

.filterUL {
    position: absolute;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding: 0;
    list-style: none;
    width: 200px;
    z-index: 1;
    transition: all 0.3ms ease-in-out;

    li {
        background-color: #A0B3C4;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid white;

        &:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        &:last-child {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            border-bottom: unset;
        }

        a {
            color: black;
            text-decoration: none;
            font-size: 14px;
        }
    }
}
.spinner {
  width: 40px;
  height: 40px;
  margin: 40px auto;
  background-color: $yellow;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}
</style>
